/* eslint-disable react/no-children-prop */
import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
// import { AddIcon } from '@chakra-ui/icons';
import { Plus } from 'phosphor-react';

interface CreateButtonProps extends ButtonProps {
  onClick?: () => void;
}

export const CreateButton = ({ onClick, children, ...rest }: CreateButtonProps) => {
  return (
    <Button
      onClick={onClick}
      w="150px"
      textTransform="uppercase"
      variant="solid"
      colorScheme="button.primary"
      boxShadow="0px 2px 4px #00000050"
      justifyContent="space-between"
      leftIcon={<Plus size={25} weight="bold" />}
      rightIcon={<div />}
      _hover={{ opacity: 0.6 }}
      {...rest}
    >
      {children}
    </Button>
  );
};
